<template>
  <div class="input-group">
    <div class="input-container" :class="{ focus: inFocus, empty: emptyValue }">
      <input class="input"
             v-on:input="onShekelInput"
             v-bind:value="value"
             v-on:keypress="preventKeys"
             :autofocus="autofocus"
             @focus="inFocus = true"
             @blur="inFocus = false"
             :placeholder="placeHolder"
             type="number"
             min="0"
             :class="{ }"/>
      <span class="currency">₪</span>
    </div>
  </div>
</template>

<script>

import _ from 'lodash';
import DDLogs from '@/DDLogs';

export default {
  name: 'ShekelInput',
  props: {
    value: {
      type: null, // this needs to accept null or number. null accepts everything.
      required: true,
    },
    onInput: {
      type: Function,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    placeHolder: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      inFocus: this.autofocus,
    };
  },
  computed: {
    emptyValue() {
      return _.isEmpty(this.value);
    },
  },
  methods: {
    preventKeys(event) {
      if (event.key === '-' || event.key === 'e') {
        return event.preventDefault();
      }
      return true;
    },
    onShekelInput(event) {
      const numberValue = Number(event.target.value);
      if (_.isNaN(numberValue)) {
        DDLogs.error('Amount is not a number!!', { value: event.target.value, originalValue: numberValue });
      }
      this.onInput(numberValue);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';

//Remove arraows from input type number

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.input-group {
  position: relative;
  width: 100%;
  height: 64px;

  .currency {
    padding-top: 5px;
    color: $riseup_black;
  }

  > .input-container {
    padding: 10px 11px 2px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    color: $riseup_black;
    font-size: 46px;
    font-weight: bold;
    border: 1px solid $riseup_gray_2;
    border-radius: 3px;
    &.focus {
      border: 1px solid $riseup_blue;
    }
    &:not(.empty):not(.focus) {
      border: 1px solid $riseup_blue;
    }

    > .input {
      padding: 0 0 3px;
      width: 100%;
      height: 100%;
      color: $riseup_black;
      font-family: SimplerPro;
      font-size: 46px;
      font-weight: bold;
      border: 0px solid;
      outline: none;

      &::placeholder {
        color: $riseup_gray_0;
      }
    }
  }
}

</style>
